<template>
<transition
  @before-enter="beforeEnter"
  @enter="enter"
  @after-enter="afterEnter"
  @before-leave="beforeLeave"
  @leave="leave"
  @after-leave="afterLeave"
>
<div v-show="isShow" class="p-polo" :class="`p-polo--${currentPoloID}`">
  <div class="c-shirt" ref="c-shirt">
    <div 
      class="c-shirt__list"
      v-for="polo in poloList" 
      :key="polo.shirt.color"
    >
      <img :src="`/special/tenkyu/10color/assets/img/polo/${polo.shirt.color}.png`" alt="">
    </div>
  </div>

  <div class="c-changeBtns">
    <ul>
      <li
        v-for="(polo, index) in poloList" 
        :key="polo.shirt.color" 
      >
        <button 
          :class="`is-circle is-circle--${polo.shirt.color}`" 
          :style="`background-color:#${polo.shirt.code};`" 
          @click="changePolo(polo.shirt.color, index)"
        >
        </button>
      </li>
    </ul>
  </div>

  <div class="c-controlBtns">
    <button 
      class="c-controlBtns__btn is-left"
      @click="changeNextPolo(-1)"
    >
      <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 8L8 14" stroke-width="2" stroke-linecap="square"/>
        <path d="M2 8L8 2" stroke-width="2" stroke-linecap="square"/>
        <path d="M22 8L2 8" stroke-width="2"/>
      </svg>
    </button>
    <button 
      class="c-controlBtns__btn is-right"
      @click="changeNextPolo(1)"
    >
      <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 8L8 14" stroke-width="2" stroke-linecap="square"/>
        <path d="M2 8L8 2" stroke-width="2" stroke-linecap="square"/>
        <path d="M22 8L2 8" stroke-width="2"/>
      </svg>
    </button>
  </div>

  <div class="c-info">
    <div class="c-info__wrap">
      <h2>POLO SHIRTS</h2>
      <ul>
        <li class="is-item">
          <span>MEN</span>
          <a :href="poloData.mens[1]" target="_blank"><span>{{ poloData.mens[0] }}</span></a>
        </li>
        <li class="is-slash"></li>
        <li class="is-item">
          <span>LADIES</span>
          <a :href="poloData.ladies[1]" target="_blank"><span>{{ poloData.ladies[0] }}</span></a>
        </li>
      </ul>
    </div>

    <button class="c-btnView" @click="openModal">
      <span>
        <span class="is-name">{{ currentPoloID }}</span>の他のアイテムを見る
      </span>
    </button>
  </div>

  <ul ref="c-colorName" class="c-colorName" @click="changeName">
    <li
      v-for="polo in poloList" 
      :key="polo.shirt.color" 
    >
      <div :class="`is-${polo.shirt.color}`" v-html="polo.shirt.color2"></div>
    </li>
  </ul>
</div>
</transition>
</template>

<script>
import { POLO_COLORS, POLO_ID, POLO_DATA } from '@/_constant/common.js';
import { gsap, Power3 } from 'gsap/gsap-core';
import { Observer } from 'gsap/Observer';

export default {
  data() {
    return {
      isPageTransition: false,
      isLink: false,
      routeFrom: null,
      currentPoloID: '',
      poloList: POLO_COLORS,
      shirtList: [],
      dObserver: null,
      poloData: POLO_DATA,
      poloMax: null,
      afterRoute: null,
    }
  },
  computed: {
    isShow() {
      return this.$store.getters.isShowPolo && this.$store.getters.isFirstLoaded;
    },
    isStart() {
      return this.$store.getters.isStartPolo;
    },
  },
  watch: {
    isShow (isNew, isOld) {
      if (isNew) {
        this.show();
      }
    },
    isStart (isNew, isOld) {
      if (isNew) {
        this.start();
      }
    },
  },

  beforeRouteEnter(to, from, next) {

    console.log(to, from);

    next((vm) => {
      vm.routeFrom = from;
      vm.currentPoloID = to.params.id;
      vm.$store.commit('setShowPolo', true);
    });
  },
  beforeRouteUpdate(to, from, next) {
    if (this.afterRoute === null) {
      // ブラウザ戻る／進む
      console.log('ブラウザボタン実行 beforeRouteUpdate');
      const nextColorName = to.params.id;
      const nextColorID = POLO_ID[nextColorName];
      const currentColorName = from.params.id;
      const currentColorID = POLO_ID[currentColorName];
      const direction = currentColorID < nextColorID ? 1 : -1;

      gsap.set(this.shirtList[currentColorID], {
        rotation: (-45 * direction),
        opacity: 0,
      });
      gsap.set(this.shirtList[nextColorID], {
        rotation: 0,
        opacity: 1,
      });
      this.changeName(nextColorName, currentColorName);
    }

    this.afterRoute = null;
    this.routeFrom = from;
    this.currentPoloID = to.params.id;
    this.$store.commit('setCurrentPoloID', this.currentPoloID);
    next();
  },
  beforeRouteLeave(to, from, next) {
    this.reset();
    next();
  },

  mounted() {
  },
  methods: {
    show() {},
    start() {
      const id = POLO_ID[this.currentPoloID];
      const tl = gsap.timeline({
        onComplete: this.startComp
      });
      tl.call(()=>{
        this.$store.commit('isBgPolo', true);
      })
      .call(()=>{
        this.$store.commit('setCurrentPoloID', this.currentPoloID);
      }, null, 0.6)
      .to(this.shirtList[id], {
        duration: 1.0,
        rotation: 0,
        opacity: 1,
        ease: Power3.easeInOut,
      }, 1.0)
      .addLabel('showUI')
      .fromTo(this.$el.querySelector('.c-changeBtns'), {
        opacity: 0,
        y: -100,
      }, {
        duration: 1.0,
        opacity: 1,
        y: 0,
        ease: Power3.easeOut,
      }, 'showUI')
      .fromTo(this.$el.querySelector('.c-info__wrap'), {
        opacity: 0,
      }, {
        duration: 1.0,
        opacity: 1,
        ease: Power3.easeOut,
      }, 'showUI')
      .fromTo(this.$el.querySelector('.c-btnView'), {
        scale: 0,
      }, {
        duration: 0.7,
        scale: 1,
        ease: Power3.easeInOut,
        stagger: 0.4,
      }, 'showUI')
      .call(() =>{
        this.changeName(this.$store.getters.currentPoloID);
      }, null, 'showUI')
      .fromTo(this.$el.querySelectorAll('.c-controlBtns > button'), {
        scale: 0,
      }, {
        duration: 0.7,
        scale: 1,
        ease: Power3.easeInOut,
        stagger: 0.4,
      }, 'showUI');
    },
    startComp() {
      this.poloMax = this.poloList.length;

      // 全体のコントロール
      this.dObserver = Observer.create({
        target: this.$el,
        type: 'wheel,touch,pointer',
        // dragMinimum: 10,
        // tolerance: 10,
        // preventDefault: true,
        // axis: 'x',
        lockAxis: true,
        // wheelSpeed: -1,
        onWheel: this.wheel,
        onPress: this.dragPress,
        onDrag: this.drag,
        onDragEnd: this.dragEnd,
      });
    },
    reset() {
      console.log('reset');
      this.isPageTransition = false;
      this.afterRoute = null;

      // ドラッグ、ホイール、タッチイベント
      if (this.dObserver) {
        this.dObserver.kill();
        this.dObserver = null;
      }

      // フラグ
      this.$store.commit('setStartPolo', false);
      this.$store.commit('setShowPolo', false);
      this.$store.commit('isBgPolo', false);
    },

    wheel() {
      if (this.isPageTransition) return;
      if (!this.isShow) return;

      const d = this.dObserver;
      if (!d) return;
      if (d.deltaY > 20) {
        this.changeNextPolo(1);
      } if (d.deltaY < -20) {
        this.changeNextPolo(-1);
      }
      
    },
    dragPress() {

    },
    drag(self) {
      const d = this.dObserver;
      if (d.axis !== 'y') return;
      if (d.y - d.startY > 20) {
        this.isLink = false;
      } else if (d.y - d.startY < -20) {
        this.isLink = true;
      }
    },
    dragEnd() {
      if (this.isPageTransition) return;
      if (!this.isShow) return;
      if (this.isLink) {
        this.changeNextPolo(1);
      } else {
        this.changeNextPolo(-1);
      }
    },

    changeNextPolo(direction) {
      const currentID = POLO_ID[this.$store.getters.currentPoloID];
      let nextID;
      if (currentID + direction < 0) {
        nextID = (this.poloMax + direction) % this.poloMax;
      } else {
        nextID = (currentID + direction) % this.poloMax;
      }
      this.changePolo(POLO_COLORS[nextID].shirt.color, nextID, direction);
    },
    changePolo(nextColorName, nextColorID, direction) {
      if (this.isPageTransition) return;
      this.isPageTransition = true;
      
      const currentColorName = this.$store.getters.currentPoloID;
      const currentColorID = POLO_ID[this.$store.getters.currentPoloID];

      if (direction === undefined) {
        direction = currentColorID < nextColorID ? 1 : -1;
      }

      this.afterRoute = {
        nextColorName: nextColorName,
        nextColorID: nextColorID,
        directoin: direction
      };
      
      const tl = gsap.timeline({
        onComplete: this.changePoloComp
      });
      tl.fromTo(this.shirtList[currentColorID], {
        rotation: 0,
      }, {
        duration: 0.7,
        rotation: (-45 * direction),
        opacity: 0,
        ease: Power3.easInOut
      })
      .fromTo(this.shirtList[nextColorID], {
        rotation: (45 * direction),
      },{
        duration: 0.7,
        rotation: 0,
        opacity: 1,
        ease: Power3.easInOut
      }, 0.3)
      .call(() => {
        this.changeName(nextColorName, currentColorName);
      }, null, 0.6);

      this.$router.push({name: 'polo', params: {id: nextColorName}});
    },
    changePoloComp() {
      this.isPageTransition = false;
    },
    

    changeName(showColor, hideColor) {
      const selectorName1 = `.is-${showColor} > span`;
      const strings1 = this.$refs['c-colorName'].querySelectorAll(selectorName1);
      let delay = 0;

      if (hideColor) {
        const selectorName2 = `.is-${hideColor} > span`;
        const strings2 = this.$refs['c-colorName'].querySelectorAll(selectorName2);

        const tl = gsap.timeline();
        tl.fromTo(strings2, {
          y: '0%',
        }, {
          duration: 0.5,
          y: '100%',
          ease: Power3.easeOut,
          stagger: 0.1,
        });

        delay = 0.1;
      }

      const tl = gsap.timeline();
      tl.fromTo(strings1, {
        y: '-100%',
      }, {
        delay: delay,
        duration: 0.5,
        y: '0%',
        ease: Power3.easeOut,
        stagger: 0.1,
      });
    },

    openModal() {
      this.$store.commit('setShowModal', true);
    },

    // transition
    beforeEnter() {
      console.log('beforeEnter');
      this.shirtList = gsap.utils.toArray(this.$refs['c-shirt'].querySelectorAll('.c-shirt__list'));
      gsap.set(this.shirtList, {rotation: 45, opacity: 0});
    },
    enter(el, done) {
      this.$store.commit('setStartPolo', true);
      done();
    },
    afterEnter() {
    },

    beforeLeave() {
    },
    leave(el, done) {
      const id = POLO_ID[this.$store.getters.currentPoloID];
      const tl = gsap.timeline({
        onComplete: () => {
          done();
        }
      });
      tl.to(this.shirtList[id], {
        duration: 1.0,
        rotation: -45,
        opacity: 0,
        ease: Power3.easeOut,
      })
      .addLabel('showUI')
      .to(el.querySelector('.c-changeBtns'), {
        duration: 1.0,
        opacity: 0,
        ease: Power3.easeOut,
      }, 'showUI')
      .to(el.querySelector('.c-info'), {
        duration: 1.0,
        opacity: 0,
        ease: Power3.easeOut,
      }, 'showUI')
      .to(el.querySelector('.c-colorName'), {
        duration: 1.0,
        opacity: 0,
        ease: Power3.easeOut,
      }, 'showUI')
      .to(el.querySelector('.c-controlBtns'), {
        duration: 1.0,
        opacity: 0,
        ease: Power3.easeOut,
      }, 'showUI');
    },
    afterLeave() {
      this.reset();
      this.$router.push({name: 'index'});
    }
  }
}
</script>